import { parse } from 'tldts'

export const extractHostname = (value: string) => {
  const url = parse(value)

  return url.hostname?.replace(/^www\./, '')
}

export const parseDomainList = (value: string): string[] =>
  value
    .split('\n')
    .map((line) => extractHostname(line))
    .filter((hostname): hostname is string => !!hostname)
